import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  devices: 'Devices',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.devices],
  endpoints: {
    getDevices: {
      providesTags: result =>
        result
          ? // successful query
            [
              ...result.map(device => ({
                type: TAG_TYPES.devices,
                id: device.id,
              })),
              { type: TAG_TYPES.devices, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Devices', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.devices, id: 'LIST' }],
    },
    getScaleReading: {},
  },
})

export const useGetScaleReadingLazyQuery = api.endpoints.getScaleReading.useLazyQuery
export const { useGetDevicesQuery, useGetScaleReadingQuery, useCreateQzTraySignatureMutation } = api
